// Shared product pool + offer maths for the cart free-slot picks (assets/ssc-free-slot.js, spec 71) and the homepage
// Gacha bundle (assets/ssc-gacha.js, prompt 76). One copy of: the best-sellers data (sections/ssc-free-slot-data.liquid
// through the Section Rendering API, cached per collection in sessionStorage), size keys, Shopify's Buy X get Y preview
// and the add-to-cart path that refreshes the drawer, tracker and toast like every other add.
(function () {
  if (window.SSCPool) return;

  var root = document.documentElement.dataset;
  var BUY = Math.max(1, parseInt(root.sscOfferBuy, 10) || 3);
  var GET = Math.max(1, parseInt(root.sscOfferGet, 10) || 1);
  var GROUP = BUY + GET;
  var TTL = 15 * 60 * 1000;
  var STORE = 'ssc-pool-v2:';
  var SHORT = { 'x-small': 'xs', small: 's', medium: 'm', large: 'l', 'x-large': 'xl', '2x-large': '2xl', xxl: '2xl', '3x-large': '3xl', xxxl: '3xl', '4x-large': '4xl' };
  var pools = {};
  var ready = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var d = cents / 100; return '$' + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function sizeKey(s) { var k = String(s || '').trim().toLowerCase(); return SHORT[k] || k; }
  function imgAt(src, w) { return src.replace(/([?&])width=\d+/, '$1width=' + w); }

  // Shopify Buy X get Y: GET units free per full set of BUY + GET (plus any free units in the open set), always the cheapest.
  function discount(prices) {
    var units = prices.slice().sort(function (a, b) { return a - b; });
    var n = units.length;
    var free = Math.floor(n / GROUP) * GET + Math.max(0, Math.min(GET, (n % GROUP) - BUY));
    var off = 0;
    for (var i = 0; i < free; i++) off += units[i];
    return off;
  }

  // Best sellers of one product-type collection: [{ h, n, t, i, a: [series, world] | null, s: { sizeKey: { id, price, rts, qty, label } } }].
  // Only orderable sizes are listed (sold-out sizes of the "-preorder" twin are merged in as made to order).
  function load(handle) {
    return loadFrom(handle, '/collections/' + encodeURIComponent(handle) + '?section_id=ssc-free-slot-data&sort_by=best-selling');
  }
  // The same list from any data section in that shape (prompt 122: sections/ssc-luck-data.liquid adds r = rank in the sort).
  function loadFrom(handle, url) {
    if (pools[handle]) return pools[handle];
    try {
      var hit = JSON.parse(sessionStorage.getItem(STORE + handle) || 'null');
      if (hit && Date.now() - hit.at < TTL) {
        ready[handle] = hit.list;
        pools[handle] = Promise.resolve(hit.list);
        return pools[handle];
      }
    } catch (e) {}
    pools[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var m = txt.match(/<script[^>]*data-ssc-fs-data[^>]*>([\s\S]*?)<\/script>/);
        var d = JSON.parse(m ? m[1] : '{}');
        var twins = d.w || {};
        var list = [];
        (d.p || []).forEach(function (p) {
          var sizes = {};
          var add = function (src) {
            Object.keys(src || {}).forEach(function (label) {
              var k = sizeKey(label);
              var v = src[label];
              if (!sizes[k]) sizes[k] = { id: v[0], price: v[1], rts: v[2] === 1, qty: v[3] || 0, label: label };
            });
          };
          add(p.s);
          add(twins[p.h]);
          if (Object.keys(sizes).length) list.push({ h: p.h, n: p.n, t: p.t, i: p.i || '', a: p.a || null, r: p.r || 0, s: sizes });
        });
        ready[handle] = list;
        try { sessionStorage.setItem(STORE + handle, JSON.stringify({ at: Date.now(), list: list })); } catch (e) {}
        return list;
      })
      .catch(function (err) { delete pools[handle]; ready[handle] = []; throw err; });
    return pools[handle];
  }
  function cached(handle) { return ready[handle]; }

  // One /cart/add.js for every item, then the same path as every other add: the drawer re-renders, the tracker pops and the
  // toast shows (Horizon + assets/ssc-manga.js). items: [{ id, quantity, properties }]. Resolves with Shopify's response.
  function addToCart(items, from, source) {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.dataset.sectionId); });
    var body = { items: items };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add failed'); return j; }); })
      .then(function (j) {
        var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add';
        ev.promise = fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          return { detail: { action: 'add', source: source, sections: j.sections, itemCount: cart.item_count } };
        });
        (from || document).dispatchEvent(ev);
        return j;
      });
  }

  window.SSCPool = {
    BUY: BUY, GET: GET, GROUP: GROUP,
    esc: esc, money: money, sizeKey: sizeKey, imgAt: imgAt,
    discount: discount, load: load, loadFrom: loadFrom, cached: cached, addToCart: addToCart
  };
})();
